import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MdSnackBar } from "@angular/material";

@Injectable()
export class AWSConnectorService {
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    })
  };
  private headers: any;
  private options: any;
  files = [];

  constructor(
    private http: HttpClient,
    private snackBar: MdSnackBar
  ) {
    this.getFiles().toPromise().then((data) => {
      if (data['error'] == false) {
        this.files = data['data'];
        console.log(this.files);
      }
    })
  }

  getFiles(bucket = 'storagepug-files') {
    return this.http.post('https://vovs5a6lw4.execute-api.us-east-1.amazonaws.com/dev/s3-file-service-storagepug-settings',
      { bucket: bucket },
      this.httpOptions);
  }

  removeFreshpingCheck(freshpingId) {
    const url = environment.lambdaApi + 'remove-freshping-check';
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    });
    var options = { headers: headers };
    return this.http.post(url, {
      "freshpingId": freshpingId
    }, options);
  }

  verifySitelinkCreds(siteLinkCorpCode, siteLinkLocationCode, siteLinkCorpUsername, siteLinkLocationPw) {
    const url = environment.lambdaApi + 'site-information';
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    });
    var options = { headers: headers };
    return this.http.post(url, {
      siteLinkCorpCode,
      siteLinkLocationCode,
      siteLinkCorpUsername,
      siteLinkLocationPw
    }, options);
  }

  helloSignGenerateLease(leaseData) {
    const url = environment.lambdaApi + 'hellosign-generate-lease';
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    });
    var options = { headers: headers };
    return this.http.post(url, {
      "testOnly": true,
      "env": environment.env,
      "clientCode": leaseData.clientCode,
      "locationKey": leaseData.locationKey,
      "leaseData": leaseData.leaseData
    }, options);
  }

  getAnalayticsKey() {
    // let url = this.baseUrl + 'update-cache/available';
    let url = environment.lambdaApi + 'google-analytics-token-generator';
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    });
    this.options = { headers: this.headers };
    return this.http.get(url, this.options);
  }

  getAllChargeTypes(clientCode, locationKey) {
    let url = environment.lambdaApi + 'charge-descriptions-retrieve';
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    });
    this.options = { headers: this.headers };
    return this.http.post(url, {
      "clientCode": clientCode,
      "locationKey": locationKey,
      "env": environment.env,
      "getAllChargeTypes": true
    }, this.options);
  }

  getAllPosItems(clientCode, locationKey) {
    let url = environment.lambdaApi + 'pos-items-retrieve';
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    });
    this.options = { headers: this.headers };
    return this.http.post(url, {
      "clientCode": clientCode,
      "locationKey": locationKey,
      "env": environment.env,
      "getAllChargeTypes": true
    }, this.options);
  }

  copyToProd(clientCode, clientKey, clientData) {
    let url = environment.lambdaApi + 'copy-from-staging-to-prod';
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    });
    this.options = { headers: this.headers };
    return this.http.post(url, {
      "clientCode": clientCode,
      "env": environment.env,
      "clientKey": clientKey,
      "clientData": clientData
    }, this.options);
  }

  eSignLeasePreviewUrl(clientCode, locationKey, unitId) {
    let url = environment.lambdaApi + 'esign-preview-lease-url';
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    });
    this.options = { headers: this.headers };
    return this.http.post(url, {
      "clientCode": clientCode,
      "locationKey": locationKey,
      "env": environment.env,
      "unitId": unitId
    }, this.options);
  }

  getObjectFromFirebase(clientCode, table, bustCache = false) {
    const url = environment.lambdaApiCache + "get-object-from-firebase?clientCode=" + clientCode + "&table=" + table;
    // const url = environment.pugConfig.siteUrl + '/api/get-object-from-fb';
    if (bustCache == false) {
      var headers = new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      });
    }
    else {
      var headers = new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "max-age=0"
      });
    }
    const options = { headers: headers };
    return this.http.post(url, {
      "apiUrl": url,
      "table": table,
      "clientCode": clientCode
    }, options);
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/aws-connector.ts